import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export const StatCard = ({ label, value, sub, icon: Icon, tone = "default", trend, testid, onClick }) => {
  const tones = {
    default: "text-slate-400 bg-slate-50",
    blue: "text-neutral-600 bg-neutral-50",
    amber: "text-amber-600 bg-amber-50",
    rose: "text-rose-600 bg-rose-50",
    emerald: "text-emerald-600 bg-emerald-50",
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      onClick={onClick}
      className={cn(
        "bg-white rounded-xl border border-slate-200 shadow-sm p-5",
        onClick && "cursor-pointer hover:shadow-md hover:border-slate-300 transition-all"
      )}
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</p>
          <p className="mt-2 font-heading text-3xl font-semibold text-slate-900">{value}</p>
        </div>
        {Icon && (
          <div className={cn("h-10 w-10 rounded-lg flex items-center justify-center", tones[tone])}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
      {sub && (
        <div className="mt-3 flex items-center gap-1.5 text-xs text-slate-500">
          {trend === "up" && <TrendingUp className="h-3.5 w-3.5 text-emerald-500" />}
          {trend === "down" && <TrendingDown className="h-3.5 w-3.5 text-rose-500" />}
          <span>{sub}</span>
        </div>
      )}
    </motion.div>
  );
};
